/** Amount fields keep the raw string: a number cannot hold "" or "7,". */

// Turkish keyboards give a comma, and parseFloat('1,5') is 1.
const TYPED_AMOUNT = /^\d*(?:[.,]\d*)?$/;

// `previous` is required: defaulting it wiped the field on a stray letter.
export const sanitizeAmount = (value: string, previous: string): string =>
  TYPED_AMOUNT.test(value) ? value : previous;

export const parseAmount = (value: string): number =>
  parseFloat(value.replace(',', '.')) || 0;
